import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const settingsAdapter = createEntityAdapter();

const initialState = settingsAdapter.getInitialState({
	view: "input"
});

const settingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		updateView(state, action) {
			state.view = action.payload
		}
	},
	extraReducers: builder => {
		builder
		.addCase("outputs/loadInitial", (state) => {
			state.view = "output"
		})
		.addCase("calculators/changeView", (state) => {
			state.view = "input"
		})
	}
})

export const {
	updateView
} = settingsSlice.actions;

export default settingsSlice.reducer;
